import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {
  clickLoginButton() {
    Cookies.set("socialLoginRedirectPath", window.location.pathname);
  }
}
